import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-mail-notification-icon',
  templateUrl: './communication-mail-notification.component.html'
})
export class CommunicationMailNotificationComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
